import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  move(event) {
    event.preventDefault()

    const link = event.target.closest("a")
    const direction = link.dataset.direction
    const itemDiv = link.closest("[data-menu-item-id]")
    // turbo-frameでラップされている場合はframe全体を移動対象にする
    const item = itemDiv.parentElement.tagName === "TURBO-FRAME"
      ? itemDiv.parentElement
      : itemDiv

    if (direction === "up") {
      const prev = item.previousElementSibling
      if (prev) {
        item.parentNode.insertBefore(item, prev)
      }
    } else {
      const next = item.nextElementSibling
      if (next) {
        next.parentNode.insertBefore(next, item)
      }
    }

    this.updateArrows()
    this.saveOrder()
  }

  updateArrows() {
    const items = this.element.querySelectorAll("[data-menu-item-id]")
    const count = items.length
    items.forEach((item, idx) => {
      const upBtn = item.querySelector('[data-direction="up"]')
      const downBtn = item.querySelector('[data-direction="down"]')
      if (upBtn) upBtn.classList.toggle("hidden", idx === 0)
      if (downBtn) downBtn.classList.toggle("hidden", idx === count - 1)
    })
  }

  saveOrder() {
    const ids = Array.from(this.element.querySelectorAll("[data-menu-item-id]"))
      .map(el => el.dataset.menuItemId)
      .filter(Boolean)

    if (ids.length === 0) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const url = this.element.dataset.sortableUrlValue
    if (!url) return

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
      },
      body: JSON.stringify({ ids })
    })
  }
}
